import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import getinvoiceaction from "../../context/action/buy/getinvoiceaction";
import Buyinvoicedetailmodal from "./buyinvoicedetailmodal";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";

const Buyinvoice = () => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [company_id, setcompany_id] = useState("");
  const [from, setfrom] = useState("");
  const [to, setto] = useState("");
  const [barcode,setbarcode]=useState("");

  const [show, setshow] = useState(false);
  const [company_invoice_id, setcompany_invoice_id] = useState();
  const [company_invoice_rmb_price, setcompany_invoice_rmb_price] = useState();
  const [company_invoice_cbi_price, setcompany_invoice_cbi_price] = useState();
  const [items, setitems] = useState([]);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      <Buyinvoicedetailmodal
        show={show}
        setshow={setshow}
        company_invoice_id={company_invoice_id}
        company_invoice_rmb_price={company_invoice_rmb_price}
        company_invoice_cbi_price={company_invoice_cbi_price}
        items={items}
        setitems={setitems}
      />
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">لیستی وەسڵی کاڵای کڕاو</h1>
          <p className="text-sm text-slate-400 mt-0.5">گەڕان و دیتنی وەسڵەکان</p>
        </div>
      </div>

      {/* Filter Section */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
        <div className="w-full">
          <label
            htmlFor="cate"
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
          >
            کۆمپانیا
          </label>
          <select
            id="cate"
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            value={company_id}
            onChange={(val) => {
              setcompany_id(val.target.value);
            }}
          >
            <option value="">کۆمپانیا هەڵبژێرە</option>
            {initState.company.map((lis) => (
              <option value={lis.company_id}>{lis.company_name}</option>
            ))}
          </select>
        </div>
        <div className="w-full">
          <label
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
            htmlFor="invoice_from"
          >
            لە بەرواری
          </label>
          <input
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            id="invoice_from"
            type="date"
            placeholder=""
            value={from}
            onChange={(val) => setfrom(val.target.value)}
          />
        </div>
        <div className="w-full">
          <label
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
            htmlFor="invoice_to"
          >
            بۆ بەرواری
          </label>
          <input
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            id="invoice_to"
            type="date"
            placeholder=""
            value={to}
            onChange={(val) => setto(val.target.value)}
          />
        </div>
        <div className="w-full">
          <label
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
            htmlFor="invoice_barcode"
          >
            کۆد
          </label>
          <input
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            id="invoice_barcode"
            type="text"
            placeholder=""
            value={barcode}
            onChange={(val) => setbarcode(val.target.value)}
          />
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              getinvoiceaction(from, to,barcode ,company_id)(recaller)(setrecaller)(
                initDispatch
              )(clear);
            }}
          >
            گەڕان
          </button>
        </div>
      </div>
      </div>
      {initState.company_invoice_item.length > 0 ? ( 
          <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
              <h2 className="text-base font-semibold text-slate-800">وەسڵی کڕاو</h2>
            </div>

            {/* Table */}
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کۆمپانیا
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        ژمارەی وەسڵ
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                       جۆری وەسڵ
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        بەروار
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        نرخی ڕێنمینبی
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        خەرجی (CBI) بەرامبەر ۱م۳
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کۆی نرخ
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کۆی نرخ (دراوی بنچینەیی)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {initState.company_invoice_item.map((lis, index) => (
                      <tr
                        key={index}
                        onClick={() => {
                          setcompany_invoice_id(lis.company_invoice_id);
                          setcompany_invoice_rmb_price(lis.company_invoice_rmb_price);
                          setcompany_invoice_cbi_price(lis.company_invoice_cbi_price);
                          var temp_items=[];
                          for(var i=0;i<lis.items.length;i++){
                            var a={
                              company_invoice_item_id:lis.items[i].company_invoice_item_id,
                              company_invoice_id:lis.items[i].company_invoice_id,
                              item_id:lis.items[i].item_id,
                              company_invoice_item_qty:(lis.items[i].company_invoice_item_qty/lis.items[i].item_unit_one_of_many),
                              company_invoice_item_price:money_rounding((lis.items[i].company_invoice_item_price-Number(lis.items[i].company_invoice_item_cbi_m3)*Number(lis.items[i].company_invoice_cbi_price))*lis.items[i].company_invoice_rmb_price),
                              company_invoice_item_cbi_m3:lis.items[i].company_invoice_item_cbi_m3,
                              company_invoice_item_cbi_total_price:lis.items[i].company_invoice_item_cbi_total_price,
                              company_invoice_date:lis.items[i].company_invoice_date,
                              company_invoice_number:lis.items[i].company_invoice_number,
                              company_invoice_rmb_price:lis.items[i].company_invoice_rmb_price,
                              company_invoice_cbi_price:lis.items[i].company_invoice_cbi_price,
                              company_id:lis.items[i].company_id,
                              company_name:lis.items[i].company_name,
                              company_address:lis.items[i].company_address,
                              company_phone:lis.items[i].company_phone,
                              item_name:lis.items[i].item_name,
                              item_barcode:lis.items[i].item_barcode,
                              item_qty:lis.items[i].item_qty,
                              item_price:lis.items[i].item_price,
                              item_base_price:lis.items[i].company_invoice_item_base_price,
                              item_unit_one:lis.items[i].item_unit_one,
                              item_unit_many:lis.items[i].item_unit_many,
                              item_unit_one_of_many:lis.items[i].item_unit_one_of_many
                            }
                            temp_items.push(a);
                          }
                          setitems(temp_items);
                          setshow(true);
                        }}
                        className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                      >
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.company_name}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.company_invoice_number}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.company_invoice_type=="cash"?"کاش":"قەرز"}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.company_invoice_date}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(lis.company_invoice_rmb_price)}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(lis.company_invoice_cbi_price)}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(
                              money_rounding(
                                lis.items.reduce(
                                (sum, item) => sum + Number(item.company_invoice_item_price*(item.company_invoice_item_qty/item.item_unit_one_of_many)),
                                0
                                )
                              )
                            )} $
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(
                              money_rounding(
                                lis.items.reduce(
                                (sum, item) => sum + Number(item.company_invoice_item_base_price*(item.company_invoice_item_qty/item.item_unit_one_of_many)),
                                0
                                )
                              )
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
      ) : null}
    </div>
  );
};

export default Buyinvoice;
